(() => {
  if (window.ineanWhatsAppTrackingReady) return;
  window.ineanWhatsAppTrackingReady = true;
  const recordIntent = (link) => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'whatsapp_click', {
      send_to: 'G-VC4VERF1GZ',
      contact_channel: 'whatsapp',
      placement: link.dataset.inquiryPlacement,
      product_id: link.dataset.inquiryProduct || undefined,
      language: document.documentElement.lang,
      page_location: window.location.origin + window.location.pathname,
      transport_type: 'beacon'
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-whatsapp-inquiry]');
    if (!link) return;
    // A click is an intent signal, never a confirmed inquiry or a purchase.
    if (window.Shopify?.customerPrivacy) recordIntent(link);
    else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], (error) => {
      if (!error) recordIntent(link);
    });
  });
})();
